import {
  GroupCodesController,
  TextFieldController,
} from '@/components/controls';
import { useSetting } from '@/hooks';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { Fragment, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { SectionSwitches } from './SectionSwitches';

export function BriefConfigurationDialog({
  brief,
  isOpen,
  onClose,
  onDelete,
  isDeleting,
}) {
  const {
    query: { data: sections },
  } = useSetting('sections');
  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: brief,
  });

  useEffect(() => {
    reset(brief);
  }, [reset, brief, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="brief-configuration-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen && !!brief} onClose={handleClose}>
        <DialogTitle>{`${brief.code ? 'Edit' : 'Add'} Brief`}</DialogTitle>
        <DialogContent>
          <Stack spacing={1} sx={{ pt: 1, maxHeight: '60vh' }}>
            {/* <DialogContentText>
              Please choose the teams and sectors you&apos;d like this brief to
              cover, and the sections you wish to see.
            </DialogContentText> */}
            <TextFieldController
              name="title"
              label="Title"
              control={control}
              rules={{ required: 'Required' }}
            />
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              types={['SECTOR', 'TEAM']}
            />
            <Typography type="subtitle2" color="textSecondary" gutterBottom>
              Sections
            </Typography>
            <Controller
              name="excludedSections"
              control={control}
              render={({ field: { value, onChange } }) => (
                <SectionSwitches
                  sections={sections}
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!brief.code && (
            <Fragment>
              <Button color="error" onClick={onDelete} disabled={isDeleting}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            form="brief-configuration-form"
            type="submit"
            disabled={isSubmitting}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
